<div class="card-primary set-language-card" @animation>
  <h2 class="language-card-title">{{ titleText }}</h2>
  <div class="language-card-content">
    <span>
      {{ descriptionText }}
    </span>
  </div>
  <div class="language-card-actions">
    <button mat-stroked-button color="warn" (click)="onCancelClickEvent()">
      {{ cancelButtonText }}
    </button>
    <app-spinner-button [config]="btnConfig" style="float: right" (onClick)="onOkClickEvent()"></app-spinner-button>
  </div>
</div>
